export const VOUCHER_UPSELL_PARAM = 'voucherUpsell';
